import { TagColor as Color } from '@factorialco/deprecated-design-system'
import { ProjectManagementProjectStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const statusTagColor: Record<ProjectManagementProjectStatusEnum, Color> = {
  active: Color.viridian,
  closed: Color.grey,
  draft: Color.champagne,
  processing: Color.purple,
}

type statusOptionsType = {
  label: string
  value: ProjectManagementProjectStatusEnum
  color: Color
}

export const stringToProjectManagementProjectStatusEnum = (
  status: string
): ProjectManagementProjectStatusEnum => {
  switch (status) {
    case 'active':
      return 'active'
    case 'draft':
      return 'draft'
    case 'closed':
      return 'closed'
    case 'processing':
      return 'processing'
    default:
      throw new Error(`Invalid status: ${status}`)
  }
}

export const StatusActions = {
  Create: 'Create',
  Update: 'Update',
  Read: 'Read',
}

interface statusOptionsProps {
  action?: string
}

export const statusOptions = ({
  action = StatusActions.Read,
}: statusOptionsProps): statusOptionsType[] => {
  const options: statusOptionsType[] = [
    {
      label: i18n.t('project_management.projects.status.active'),
      value: 'active',
      color: statusTagColor['active'],
    },
    {
      label: i18n.t('project_management.projects.status.draft'),
      value: 'draft',
      color: statusTagColor['draft'],
    },
    {
      label: i18n.t('project_management.projects.status.closed'),
      value: 'closed',
      color: statusTagColor['closed'],
    },
  ]
  if (action == StatusActions.Read) {
    options.push({
      label: i18n.t('project_management.projects.status.processing'),
      value: 'processing',
      color: statusTagColor['processing'],
    })
  }
  return options
}

export const isValidProjectStatus = (
  status: string
): status is ProjectManagementProjectStatusEnum => {
  return ['active', 'draft', 'closed', 'processing'].includes(status)
}
